import React, { useState } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import Sidebar from '../Sidebar'
import Toastification from '../Toastification'
import { ContainerBox, ContentBox } from './styles'
import Breadcrumbs from '~/components/Breadcrumbs'
import Navbar from '~/components/Navbar'

type ContainerProps = {
  children: React.ReactNode
}

const breadcrumbNameMap: { [key: string]: string } = {
  'users/list': 'Users List',
}

const Container: React.FunctionComponent<ContainerProps> = ({
  children,
}: ContainerProps) => {
  const [fullSideBar, setFullSidebar] = useState(true)
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'))

  const appwidth = (): string => {
    if (isSmallScreen) return '100%'
    if (fullSideBar) return 'calc(100% - 200px)'
    if (!fullSideBar) return 'calc(100% - 56px)'
    return '100%'
  }

  const navigate = useNavigate()
  const location = useLocation()
  const pathnames = location.pathname.split('/').filter((x) => x)

  const handleBreadcrumb = (href: string) => {
    navigate(href)
  }

  return (
    <ContentBox flexDirection={isSmallScreen ? 'column' : 'row'}>
      <Sidebar widthChanged={(value: boolean) => setFullSidebar(value)} />

      <ContainerBox
        px={{ xs: 1.5, sm: 1.5, md: 3 }}
        py={{ xs: 1.5, sm: 1.5, md: 3 }}
        appwidth={appwidth()}
      >
        <Navbar />
        <Breadcrumbs
          nameMap={breadcrumbNameMap}
          handleClick={handleBreadcrumb}
          pathnames={pathnames}
        />
        {children}
        <Toastification />
      </ContainerBox>
    </ContentBox>
  )
}

export default Container
